import "./carousel.css";
import Carousel from "react-material-ui-carousel";
import KitchenTable from "../../../assets/amenities/kitchen-table.jpeg";
import Kitchen from "../../../assets/amenities/kitchen.jpeg";
import RoomEntry from "../../../assets/amenities/room-entry.jpeg";
import Room1 from "../../../assets/amenities/room1.jpeg";
import Shower from "../../../assets/amenities/shower.jpeg";
import WashingRoom from "../../../assets/amenities/washing-room.jpeg";
import RenderHouseImg from "../../../assets/general/render.png";
import GreenAreaImg from "../../../assets/amenities/GreenArea.jpeg";
import LivingRoomImg from "../../../assets/amenities/LivingRoom.jpeg";
import RoomCactusImg from "../../../assets/amenities/RoomCactus.jpeg";

import { CardMedia } from "@mui/material";

const images = [
  { photo: RenderHouseImg, description: "Render de la residencia" },
  { photo: GreenAreaImg, description: "Área aire libre" },
  { photo: LivingRoomImg, description: "Sala" },
  { photo: Kitchen, description: "Cocina" },
  { photo: KitchenTable, description: "Comedor" },
  { photo: RoomCactusImg, description: "Habitación" },
  { photo: RoomEntry, description: "Entrada de habitación" },
  { photo: Room1, description: "Habitación" },
  { photo: Shower, description: "Baño" },
  { photo: WashingRoom, description: "Lavandería" },
];

function CarouselPage() {
  return (
    <Carousel
      autoPlay={true}
      animation="slide"
      duration={1000}
      className="carousel"
      height={400}
      navButtonsAlwaysVisible
    >
      {images.map((image, index) => (
        <CardMedia
          component="img"
          key={index}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            objectFit: "contain",
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            margin: "auto",
          }}
          image={image.photo}
          title={image.description}
        />
      ))}
    </Carousel>
  );
}

export default CarouselPage;
